import React from 'react';
import './Footer.css'

const Footer = () => {
     return (
          <div>

               <div className='footer bg-dark text-white mt-4'>
                    <div>
                         <h5>ON LINE CLASS</h5>
                         <p>If you like to come here once and see, you and your son and daughter will come to study with me, just visit once</p>
                         <p>Mobile : 01985511507</p>
                         <p><small>mdmaruf5511507@gmail.com</small></p>

                    </div>
                    <div>
                         <h5 className='ms-4'>ALL CODING </h5>
                         <ul>
                              <li>HTML</li>
                              <li>CSS</li>
                              <li>Github</li>
                              <li>javasCript</li>
                              <li>React</li>
                              <li>nodeJS</li>
                              <li>mongoDB</li>
                         </ul>
                    </div>
                    <div>
                         <h5 className='ms-4'>ALL TIME</h5>
                         <ul>
                              <li>Morming 9.30</li>
                              <li>Noon 6.50</li>
                              <li>Evening 12.30</li>
                              <li>Morming 1.20</li>
                              <li>Night 2.30</li>
                              <li>Morming 9.23</li>
                              <li>Evening 4.30</li>
                         </ul>
                    </div>
                    <div>
                         <h4 >SUBSCRIBE</h4>
                         <p>
                              <input type="text" />
                              <input type="submit" value="GO NOW" />
                         </p>
                    </div>
               </div>
          </div>
     );
};

export default Footer;